module.exports = __webpack_public_path__ + "img/sleeve cuff width.42e39f42.png";